export default function auth({next, store}) {
  if (!store.getters["user/gProfile"]) {
    next({name: "Profiles"});
  }
  return next();
}